/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentitySettingsListConfiguration
 */
export interface IdentitySettingsListConfiguration {
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof IdentitySettingsListConfiguration
     */
    readonly brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof IdentitySettingsListConfiguration
     */
    readonly distributionChannels?: Array<Int32IdAndLabel> | null;
}

export function IdentitySettingsListConfigurationFromJSON(json: any): IdentitySettingsListConfiguration {
    return IdentitySettingsListConfigurationFromJSONTyped(json, false);
}

export function IdentitySettingsListConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentitySettingsListConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
    };
}

export function IdentitySettingsListConfigurationToJSON(value?: IdentitySettingsListConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


